import React, {useState} from 'react';
import __ from "lodash";
import moment from "moment";
import {Table, TableBody, TableCell, TableHead, TableRow, Toolbar} from "@material-ui/core";
import {ChromeTabs} from '../../../controls';
import { useBlendedRates } from '../../../services/aircraft';
import { useQueryClient } from 'react-query';

const ViewBlendedRates = (props) => {
  const queryClient = useQueryClient();
  const classes = props.classes;

  const [tabs, setTabs] = useState([{label: `No Data`, value: ""}]);
  const [currentTab, setCurrentTab] = useState("");

  const blendedRates = useBlendedRates({queryClient, extraKeys: [moment().startOf('month').subtract(5, 'month').format('YYYY-MM-DD'), 12], callback: (blendedRateData)=> {
    if(currentTab !== "") {
      return;
    }
    let newTabs = [{label: `No Data`, value: ""}];
    if (blendedRateData && Object.keys(blendedRateData).length > 0) {
      newTabs = Object.keys(blendedRateData).map((key) => {return {label: key, value: key}});
      setTabs(newTabs);
    }
    setCurrentTab(newTabs[0].value);
  }})

  const handleTabChange = (e, i) => {
    setCurrentTab(i);
  }

  return (
    <div>
      {tabs.length > 1 &&
        <Toolbar>
          <ChromeTabs
            id={"ViewBlendedRates"}
            style={{ alignSelf: "flex-end" }}
            tabs={tabs}
            tabStyle={{
              bgColor: "#E6E8EB",
              selectedBgColor: "#ffffff",
              color: "rgba(0,0,0,0.87)",
            }}
            tabProps={{
              disableRipple: false,
            }}
            value={currentTab}
            onChange={handleTabChange}          
          />
        </Toolbar>
      } 
      {__.has(blendedRates?.data, currentTab)?
        <div style={{lineHeight: 1, fontSize:"14px", fontFamily: "monospace", color: "#202020", whiteSpace: "pre", backgroundColor: "#ffffff"}}>
          <Table className={classes?.blendedRates} style={{border: "solid 1px #b9b9b9"}}>
            <TableHead>
            <TableRow style={{backgroundColor: "#f0f0f0"}}>
                <TableCell style={{paddingTop: 4, paddingBottom: 4, backgroundColor: "#eaeaea"}} width="100px"></TableCell>
                {blendedRates.data[currentTab].monthDates.map((date, i) => (
                  <TableCell style={{paddingTop: 4, paddingBottom: 4, textAlign:"center", backgroundColor: i % 2 === 1 ? "#eaeaea" : "#f0f0f0"}} colSpan={2} width="120px">{date}</TableCell>
                ))}
              </TableRow>
              <TableRow style={{backgroundColor: "#f0f0f0"}}>
                <TableCell style={{paddingTop: 4, paddingBottom: 4}} width="100px">Tail</TableCell>
                {blendedRates.data[currentTab].monthDates.map((date, i) => (
                  <>
                  <TableCell style={{paddingTop: 4, paddingBottom: 4, textAlign:"center", backgroundColor: i % 2 === 1 ? "#eaeaea" : "#f0f0f0"}} width="50px" >MGH</TableCell>
                  <TableCell style={{paddingTop: 4, paddingBottom: 4, textAlign:"center", backgroundColor: i % 2 === 1 ? "#eaeaea" : "#f0f0f0"}} width="70px" >ACMI</TableCell>
                  </>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(blendedRates.data[currentTab].monthData).map((aircraftTail, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell style={{backgroundColor: "#f6f6f6"}}>{aircraftTail}</TableCell>
                    {blendedRates.data[currentTab].monthData[aircraftTail].map((record, j) => {
                      const {mgh, acmiRate} = record;
                      return (
                        <>
                        <TableCell style={{backgroundColor: j % 2 === 1 ? "#f9f9f9" : "#ffffff"}} width="50px" align="right">{mgh}</TableCell>
                        <TableCell style={{backgroundColor: j % 2 === 1 ? "#f9f9f9" : "#ffffff"}} width="70px" align="right">{acmiRate}</TableCell>
                        </>
                      )
                    })}
                  </TableRow>
                )
              })}  
              <TableRow style={{backgroundColor: "#f0f0f0"}}>
                <TableCell style={{paddingTop: 4, paddingBottom: 4, backgroundColor: "#eaeaea"}} width="100px">Blended</TableCell>
                {blendedRates.data[currentTab].totals.map((blendedRate, i) => (
                  <>
                  <TableCell style={{paddingTop: 4, paddingBottom: 4, textAlign:"right", backgroundColor: i % 2 === 1 ? "#eaeaea" : "#f0f0f0"}} width="50px" align="right"></TableCell>
                  <TableCell style={{paddingTop: 4, paddingBottom: 4, textAlign:"right", backgroundColor: i % 2 === 1 ? "#eaeaea" : "#f0f0f0", fontWeight: "bold"}} width="70px" align="right">{blendedRate}</TableCell>
                  </>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </div>
      : 
        <div style={{lineHeight: 1, fontSize:"20px", color: "#202020", backgroundColor: "#ffffff", width: "calc(100% - 80px)", minHeight: 200, padding: '50px 40px'}}>
          <div style={{textAlign: 'center', width: '100%'}}>{blendedRates?.isLoading ? "Loading..." : "There does not appear to be any blended rates to show"}</div>  
        </div>
      }
    </div>
  );
}

const viewBlendedRatesPopup = (title, SystemData) => {
  let blendedRates = (<ViewBlendedRates SystemData={SystemData}/>);
  SystemData.confirm(
    `${title}`,
    blendedRates,
    [{label: "Close", value: "close"}],
    () => {blendedRates = null},
    {dialogOptions: {style:{zIndex: 5000}, maxWidth: 1200, fullWidth: true, PaperProps:{style: {backgroundColor: "rgb(240, 240, 240)"}}}}
  );
}

export default ViewBlendedRates;
export {viewBlendedRatesPopup};